import { render, staticRenderFns } from "./SplitPanelModal.vue?vue&type=template&id=1b47bb59&scoped=true"
import script from "./SplitPanelModal.vue?vue&type=script&lang=js"
export * from "./SplitPanelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b47bb59",
  null
  
)

export default component.exports